export default "__VITE_ASSET__3a7638aa__"